import React from 'react';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { Problem } from './components/Problem';
import { FailedSolutions } from './components/FailedSolutions';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoFor } from './components/WhoFor';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
import { Divider } from './components/ui';
export function App() {
  return <div className="min-h-screen bg-midnight text-parchment font-sans relative bg-noise" data-id="element-0">
      <Hero data-id="element-1" />
      <Divider data-id="element-2" />
      <Hook data-id="element-3" />
      <Problem data-id="element-4" />
      <FailedSolutions data-id="element-5" />
      <Divider data-id="element-6" />
      <Mechanism data-id="element-7" />
      <WhatYouGet data-id="element-8" />
      <Divider data-id="element-9" />
      <WhoFor data-id="element-10" />
      <HowItWorks data-id="element-11" />
      <Proof data-id="element-12" />
      <Divider data-id="element-13" />
      <FAQ data-id="element-14" />
      <Offer data-id="element-15" />
      <Footer data-id="element-16" />
    </div>;
}